var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoyalfans = function SvgLoyalfans(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20311_98161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50476 3.09107C7.28341 2.32426 8.58116 2.32426 9.35981 3.09107C10.1385 3.85789 10.1385 5.13591 9.35981 5.90272C8.58116 6.66953 7.28341 6.66953 6.50476 5.90272C5.72611 5.13591 5.70016 3.85789 6.50476 3.09107ZM19.4693 0.407227L12.2797 9.20002C12.1759 9.32782 12.0591 9.4684 11.9553 9.5962C11.4103 10.2991 10.9301 11.0531 10.5537 11.8583C9.78807 13.4558 9.34683 15.2451 9.34683 17.1493V19.7437H6.49179V17.0215C6.49179 16.7915 6.49179 16.5614 6.47881 16.3186C6.38797 14.6827 5.97269 13.1619 5.31083 11.7688C5.14213 11.4238 4.96044 11.0915 4.76578 10.7464L4.68791 10.6186L0.132812 3.14219L7.94527 9.6601L19.4693 0.407227Z",
    fill: "#D90A16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20311_98161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3365,
    height: 19.3365,
    fill: "white",
    transform: "translate(0.132812 0.407227)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoyalfans);
export default ForwardRef;